import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import StoryblokLink from "../../internal/storyblokLink/StoryblokLink"

import * as styles from "./PromotedMediaPanel.module.scss"
import { resolveRichText } from "../../../utils/richText"

const PromotedMediaPanel = ({ blok }) => {
  
  return (
    <PanelWrapper blok={blok}>
      <div className="shadow-cards">
        <Container className="panel-radius">
          <Row>
            <Col xs={12} lg={7} className="bg-dark">
              {blok.image ? <StoryblokImage sbImageData={blok.image} /> : null}
            </Col>
            <Col xs={12} lg={5} className={styles.rightCol}>
              <div className={styles.content}>
                {blok.headline ? <h3>{blok.headline}</h3> : null}
                {blok.text ? <div dangerouslySetInnerHTML={resolveRichText(blok.text)}></div> : null}
                {blok.cta_text ? <StoryblokLink SBLinkData={blok.cta_link} withClass="btn start-green" text={blok.cta_text} newWindow={blok.cta_target === "_blank" ? true : false} /> : null}
                {blok.post_cta_text ? <div dangerouslySetInnerHTML={resolveRichText(blok.post_cta_text)}></div> : null}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </PanelWrapper>
  )
}

export default PromotedMediaPanel